/**
 * 푸터 색 토큰.
 *
 * 원래 푸터는 `bg-neutral-950` + `text-white/*` 로 **라이트/다크 구분 없이 항상
 * 어두웠다.** 헤더·본문은 테마를 따르는데 푸터만 안 따라가면, 라이트 모드에서
 * 페이지 끝에 검은 덩어리가 붙는다.
 *
 * Tailwind 는 클래스 문자열을 정적으로 스캔하므로 조합해서 만들 수 없다. 그래서
 * 값이 아니라 **완성된 클래스 문자열**을 여기 모아두고, 푸터들이 같은 걸 쓴다.
 * (`APP_HEADER` 와 같은 규약)
 */
export const FOOTER_TONE = {
  /** 푸터 바탕. 라이트는 본문과 구분되는 옅은 면, 다크는 기존 검정 유지. */
  root: 'bg-neutral-100 text-neutral-600 dark:bg-neutral-950 dark:text-white/70',
  /** 위 컨텐츠와 갈라주는 경계. 라이트에서 배경만으로는 경계가 약하다. */
  edge: 'border-t border-neutral-200 dark:border-transparent',
  /** 상단 미니 내비 링크 */
  navLink:
    'text-neutral-700 hover:text-neutral-950 dark:text-white/80 dark:hover:text-white',
  /** 강조 링크(개인정보 처리방침) */
  navLinkStrong:
    'font-bold text-neutral-950 hover:text-black dark:text-white dark:hover:text-white',
  /** 내비 항목 사이 세로 구분선 */
  navDivider: 'bg-neutral-300 dark:bg-white/15',
  /** 사업자 정보 등 보조 텍스트 */
  meta: 'text-neutral-500 dark:text-white/40',
  /** 보조 텍스트 중 강조(상호 등) */
  metaStrong: 'text-neutral-700 dark:text-white/55',
  /** 보조 텍스트 안의 링크 hover */
  metaLink: 'hover:text-neutral-900 dark:hover:text-white/70',
  /** 가운뎃점 구분자 */
  dot: 'text-neutral-300 dark:text-white/20',
  /** 카피라이트 위 구분선 */
  rule: 'border-t border-neutral-200 dark:border-white/[0.06]',
  /** 카피라이트 */
  copyright: 'text-neutral-400 dark:text-white/35',
  /**
   * 로고. 단색 로고 전제 — 라이트에서는 원본, 다크에서는 흰색으로 뒤집는다.
   * 헤더 로고와 같은 규칙이라 두 곳의 로고가 따로 놀지 않는다.
   */
  logo: 'dark:brightness-0 dark:invert',
} as const;
